//import 'bootstrap'
const jQuery = require( 'jquery' );
window.jQuery = window.$ = jQuery;
require( './onepage-scroll-1.3.1/jquery.onepage-scroll.min' );
require( 'waypoints/lib/noframework.waypoints.min' );
// require( 'waypoints/lib/shortcuts/inview.min' );
import 'jquery.scrollto';
import Navigo from 'navigo';
var root ='https://rivrcreativ.co';

(function ( $ ) {
  $( function () {

    const $main = $( '.main' );
    const $arrows = $( '.arrow-down, .arrow-up' );
    const $body = $( 'body' );
    const $burger = $( '.navbar-toggler' );
    const $mainNav = $( '.main-nav' );
    const $mainNavLinks = $mainNav.find( '.main-nav-link' ).not( '[data-file]' );
    const $sections = $( '.main section' );
    const router = new Navigo( root, false );
    let currentSectionId = null;

    $burger.on( 'click tap', function () {
      $body.toggleClass( 'menu-active' );
    } );

    $main.onepage_scroll( {
      easing: 'cubic-bezier(.43,0,.11,1)',
      animationTime: 800,
      pagination: false,
      updateURL: false,
      loop: false,
      responsiveFallback: 990, //below 1000px switch to normal scrolling
      beforeMove: function ( index ) {
        //$arrows.addClass( 'hide' );
        $body.addClass( 'transitioning' );
      },
      afterMove: function ( index ) {
        $body.removeClass( 'transitioning' );
        /*setTimeout( function () {
          $arrows.removeClass( 'hide' );
        }, 500 );*/

        /* $activeSection = $sections.filter( '.active' );
         $body.removeClass( 'alt-style' );
         if ( $activeSection.hasClass( 'alt-style' ) ) {
           $body.addClass( 'alt-style' );
         }*/

        $mainNavLinks
          .removeClass( 'active' )
          .filter( `[data-rel-index=${index}]` )
          .addClass( 'active' );
      }
    } );

    const getCurrentSection = () => {
      return $sections.filter( '.active' );
    }

    const closeMenu = () => {
      $body.removeClass( 'menu-active' );
    }

    router.historyAPIUpdateMethod( 'pushState' );

    router.on( {
      '/:section': ( params ) => {

        currentSectionId = params.section;

        const p = new Promise( function ( resolve, reject ) {
          if ( $body.hasClass( 'menu-active' ) ) {
            closeMenu();
            setTimeout( resolve, 800 );
          } else {
            resolve();
          }
        } );

        p.then( function () {
          // scrollToItemId( params.section );
          if ( $body.hasClass( 'disabled-onepage-scroll' ) ) {
            //console.log( 'scrolling', $( '#' + params.section ) );
            //scrollToItemId( params.section );

            $body.scrollTo( $( '#' + params.section ), {
              axis: 'y',
              duration: 800
            } );

          } else {
            $main.moveTo( $sections.filter( `#${params.section}` ).data( 'index' ) );
          }

        } );

      }
    } );

    router.resolve();

    $( '.arrow-down' ).on( 'click tap', function ( e ) {
      e.preventDefault();
      router.navigate( `/${getCurrentSection().next().attr( 'id' )}` );
    } );

    $( '.arrow-up' ).on( 'click tap', function ( e ) {
      e.preventDefault();
      router.navigate( `/${getCurrentSection().prev().attr( 'id' )}` );
    } );

    const scrollToItemId = ( scrollToId ) => {
      const scrollContainer = $( 'html' ).get( 0 );
      console.log( "OK" );
      const item = document.getElementById( scrollToId );
      //with animation
      const from = scrollContainer.scrollTop;
      let by = item.offsetTop - scrollContainer.scrollTop;

      if ( from < item.offsetTop ) {
        if ( item.offsetTop > scrollContainer.scrollHeight - scrollContainer.clientHeight ) {
          by = (scrollContainer.scrollHeight - scrollContainer.clientHeight) - scrollContainer.scrollTop;
        }
      }
      let currentIteration = 0;
      console.log( "by", scrollContainer.scrollHeight, scrollContainer.clientHeight, scrollContainer.scrollTop );
      console.log( scrollContainer.scrollTop, item.offsetTop, by );
      //console.log(scrollContainer.scrollHeight, scrollContainer.clientHeight);
      /**
       * get total iterations
       * 60 -> requestAnimationFrame 60/second
       * second parameter -> time in seconds for the animation
       **/
      const animIterations = Math.round( 60 * 1 );

      (function scroll () {
        const value = Math.easeInOutCubic( currentIteration, from, by, animIterations );
        scrollContainer.scrollTop = value;
        currentIteration++;
        if ( currentIteration < animIterations ) {
          requestAnimationFrame( scroll );
        }
      })();
    }

    Math.easeInOutCubic = function ( t, b, c, d ) {
      t = t / (d / 2);
      if ( t < 1 ) return c / 2 * Math.pow( t, 3 ) + b;
      t = t - 2;
      return c / 2 * (Math.pow( t, 3 ) + 2) + b;
    };

    $mainNavLinks.on( 'click tap', function ( e ) {
      e.preventDefault();
      const $link = $( this );
      const link_index = $link.data( 'rel-index' );
      const id = $sections.filter( `[data-index=${link_index}]` ).attr( 'id' );

      if ( id === currentSectionId ) {
        closeMenu();
      } else {
        router.navigate( `/${id}` );
      }
    } )

    //WAYPOINTS
    const $contentsections = $( '.section' );

    $contentsections.each( function ( index ) {
      const el = this;
      var currentIndex = index;
      let $currentEl = null;

      new Waypoint( {
        element: el,
        handler: function ( direction ) {
          const $el = $( this.element );

          if ( direction === 'down' ) {
            $currentEl = $el;
            currentIndex = index;
          } else {
            //direction is up, we need to see what section is ahead of us
            $currentEl = $el.prev();
            currentIndex = index - 1;
          }

          if ( $currentEl.hasClass( 'alt-style' ) ) {
            $body.addClass( 'alt-style' );
          } else {
            $body.removeClass( 'alt-style' );
          }

          $body.removeClass( 'past-home' );
          if ( currentIndex >= 1 ) {
            $body.addClass( 'past-home' );
          }

        },
        context: document.body,
        offset: 25
      } );
    } );

    /* $(window).resize(function() {
       if( $body.hasClass('disabled-onepage-scroll') ) {
         //fallback to zenscroll

       }
     });*/

  } )
})( jQuery );



// WEBPACK FOOTER //
// ./assets/js/index.js